{
  "id": 1,
  "displayOrder": 1,
  "parentId": null,
  "createdBy": 1,
  "dateCreated": 1677181160,
  "lastUpdated": 1718809092,
  "publishDate": null,
  "status": "PUBLISHED",
  "identifiers": [
    {
      "id": 1,
      "pageId": 1,
      "zoneId": 1,
      "languageId": 1,
      "url": "default",
      "name": "Home",
      "description": "Home page description",
      "tags": []
    }
  ],
  "meta": {
    "description": "Home page description",
    "dragDrop": "true",
    "iconAlign": "center top",
    "sectionEdit": "true",
    "showFooterBar": "'true'",
    "showInMenu": "true",
    "showSitemap": "'true'"
  },
  "permissions": [],
  "zone": 1,
  "tags": [],
  "widgets": [
    {
      "id": 8399,
      "pageId": 1,
      "widgetId": 1,
      "parentId": null,
      "displayOrder": 1,
      "data": {
        "columnsNormal": 12,
        "title": ""
      },
      "permissions": [],
      "nodes": [],
      "identifier": "WRAPPER",
      "content": [
        {
          "id": 8400,
          "pageId": 1,
          "widgetId": 1,
          "parentId": 8399,
          "displayOrder": 1,
          "data": {
            "columnsNormal": "full-width",
            "name": "Section",
            "sectionTracker": 0
          },
          "permissions": [],
          "identifier": "WRAPPER",
          "nodes": [],
          "content": [
            {
              "id": 10349,
              "pageId": 1,
              "widgetId": 13,
              "parentId": 8400,
              "displayOrder": 1,
              "data": {
                "col": 0,
                "emptyWriteTemplate": "",
                "name": "Uno Pago",
                "row": 0,
                "sizeX": 12,
                "text": "",
                "toggle": ""
              },
              "permissions": [],
              "nodes": [],
              "content": [],
              "widget": 13,
              "languageData": [],
              "uid": 10349,
              "identifier": "ONE-PAGE"
            }
          ]
        }
      ]
    }
  ],
  "children": [],
  "categories": [],
  "parents": [],
  "url": "default",
  "name": "Home",
  "description": "Home page description",
  "categoryNames": [],
  "hasChildren": false
}
